import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { LottoItem } from './models/lotto-item.model';

export interface LottoState extends EntityState<LottoItem> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'lotto', idKey: 'LottoId', cache: { ttl: 20000 } })
export class LottoStore extends EntityStore<LottoState> {
  constructor() {
    super();
  }
}
